import { useEffect, useRef, useState } from 'react';

const themeByPlanet = {
  suma: 'suma',
  resta: 'resta',
  mult: 'multiplicacion',
  multiplicacion: 'multiplicacion',
  division: 'division',
};

const CosmicPracticeImpulse = ({ impulse, onComplete }) => {
  const continueButtonRef = useRef(null);
  const [canContinue, setCanContinue] = useState(false);

  useEffect(() => {
    if (!impulse) {
      setCanContinue(false);
      return undefined;
    }
    setCanContinue(false);
    const revealTimer = window.setTimeout(() => {
      setCanContinue(true);
      continueButtonRef.current?.focus();
    }, 1000);
    return () => window.clearTimeout(revealTimer);
  }, [impulse]);

  if (!impulse) return null;
  const theme = themeByPlanet[impulse.planetId] || 'suma';

  return (
    <section
      className={'tmag-practice-impulse tmag-practice-impulse--' + theme}
      role="dialog"
      aria-modal="true"
      aria-labelledby="practice-impulse-title"
      aria-describedby="practice-impulse-message"
    >
      <div className="tmag-practice-impulse__card">
        <span className="tmag-practice-impulse__spark tmag-practice-impulse__spark--left" aria-hidden="true">✦</span>
        <span className="tmag-practice-impulse__spark tmag-practice-impulse__spark--right" aria-hidden="true">✧</span>
        <p id="practice-impulse-title" className="tmag-practice-impulse__eyebrow">✦ IMPULSO CÓSMICO</p>
        <p id="practice-impulse-message" className="tmag-practice-impulse__message">{impulse.message.message}</p>
        <button
          ref={continueButtonRef}
          type="button"
          className={'tmag-practice-impulse__continue' + (canContinue ? ' is-visible' : '')}
          disabled={!canContinue}
          onClick={onComplete}
        >
          SEGUIR PRACTICANDO <span aria-hidden="true">→</span>
        </button>
      </div>
    </section>
  );
};

export default CosmicPracticeImpulse;
